import React, { useState, useContext } from "react";
import {
  Typography,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import CalculatedFinalNetPayForm from "./CalculatedFinalNetPayForm";
import { CreatedReportTerminationContext } from "./ReportTerminationContext";
import { FinalPay } from "generated/graphql";

const FinalPayDetails = () => {
  const [finalPayType, setFinalPayType] = useState<FinalPay>(
    FinalPay.DirectDepositOnly
  );
  const [showCalculatedFinalNetPay, setShowCalculatedFinalNetPay] = useState(
    false
  );
  const { dispatch } = useContext(CreatedReportTerminationContext);

  const handleChange = (event: React.ChangeEvent<unknown>, value: string) => {
    const finalPayType = value as FinalPay;
    setFinalPayType(finalPayType);
    setShowCalculatedFinalNetPay(finalPayType === FinalPay.PaperCheckOnly);

    dispatch({ type: "updateFinalPayType", finalPayType });
  };

  return (
    <>
      <FormControl>
        <Typography variant={"h2"}>Final Pay Details</Typography>
        <Typography variant={"h6"}>
          The user was updated successfully. How should they receive their final
          pay?:{" "}
        </Typography>
        <RadioGroup
          name={"finalPayDetailsRadioGroup"}
          onChange={handleChange}
          value={finalPayType}
        >
          <FormControlLabel
            value={FinalPay.DirectDepositOnly}
            control={<Radio color="primary" id="#input_noChange" />}
            label="No change (final pay only through direct deposit to DailyPay account)"
            labelPlacement="end"
          />
          <FormControlLabel
            value={FinalPay.PaperCheckOnly}
            control={<Radio color="primary" id="#input_paperCheckDeductions" />}
            label="Paper check (deductions allowed with invoice request from DailyPay)"
            labelPlacement="end"
          />
          <FormControlLabel
            value={FinalPay.PaperCheckNoDeduction}
            control={
              <Radio color="primary" id="#input_paperCheckNoDeductions" />
            }
            label="Paper check (no deductions allowed)"
            labelPlacement="end"
          />
        </RadioGroup>
        {showCalculatedFinalNetPay && <CalculatedFinalNetPayForm />}
      </FormControl>
    </>
  );
};

export default FinalPayDetails;
